module.exports = __webpack_public_path__ + "static/media/key-circle.c9d7462d.svg";